import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Bot, LogOut, User, Settings, ChevronDown } from 'lucide-react';
import './Header.css';

const Header = () => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getInitials = (name) => {
    return name
      ?.split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2) || 'U';
  };

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo">
          <div className="logo-icon">
            <Bot size={24} />
          </div>
          <div className="logo-text">
            <span className="logo-title">Enterprise AI</span>
            <span className="logo-subtitle">Agent Platform</span>
          </div>
        </div>
      </div>

      <div className="header-right">
        <div className="user-menu" ref={dropdownRef}>
          <button
            className="user-menu-trigger"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="avatar">
              {getInitials(user?.name)}
            </div>
            <div className="user-info">
              <span className="user-name">{user?.name}</span>
              <span className="user-role">{user?.role}</span>
            </div>
            <ChevronDown size={16} className={`dropdown-arrow ${showDropdown ? 'open' : ''}`} />
          </button>

          {showDropdown && (
            <div className="dropdown-menu">
              <div className="dropdown-header">
                <span className="dropdown-email">{user?.email}</span>
                {user?.company && (
                  <span className="dropdown-company">{user.company}</span>
                )}
              </div>
              <div className="dropdown-divider" />
              <button className="dropdown-item">
                <User size={16} />
                <span>Profile</span>
              </button>
              <button className="dropdown-item">
                <Settings size={16} />
                <span>Settings</span>
              </button>
              <div className="dropdown-divider" />
              <button className="dropdown-item dropdown-item-danger" onClick={logout}>
                <LogOut size={16} />
                <span>Sign out</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
